export default "__VITE_ASSET__BhHWKycp__"